import loadable from '@loadable/component'
import Loading from 'components/Loading/Loading'
import { timeout } from 'promise-timeout'
import React from 'react'
import { TIMEOUT_LOADER } from 'utils/globals'

const PromotorECPFList = loadable(
  () => timeout(import(
    /* webpackChunkName: "PromotorECPF" */
    'ecpf/app/PromotorECPF/views/PromotorECPFList/PromotorECPFList'
  ), TIMEOUT_LOADER),
  {
    fallback: <Loading/>
  }
)

export { PromotorECPFList }
